import { DeviceInfo } from '../../device/data/device-info';

export enum AndroidGroupType {
    And_44 = '4.4',
    And_71 = '7.1',
    And_9 = '9.0',
    And_12 = '12.0',
    And_13 = '13.0'
}

export enum FwUpdateStatus {
    CHECKING = 'CHECKING',
    WAITING_INSTALL = 'WAITING_INSTALL',
    WAITING_CHECK = 'WAITING_CHECK',
    INSTALLING = 'INSTALLING',
    WAITING_REBOOT = 'WAITING_REBOOT',
    UPDATE_STATUS_UNKNOWN = 'UPDATE_STATUS_UNKNOWN',
    CHECK_FAILED = 'CHECK_FAILED',
    DOWNLOAD_FAILED = 'DOWNLOAD_FAILED',
    INSTALL_FAILED = 'INSTALL_FAILED'
}

export class FirmwareUpdateInfo {
    modelName: string;
    modelDescription: string;
    PCBRevision: number;
    firmwareVersion: string;
    link: string;
    releaseDate: string;
    notice: string;
}

export enum FwUpdateMethod {
    Unknown = 1,
    Latest,
    FromURL
}

export class FirmwareUpdateScheduleInfo {
    enabled: boolean;
    date: string;
    time: string;
    offset: number;

    constructor() {
        this.enabled = false;
        this.date = '';
        this.time = '00:00';
        this.offset = -(new Date().getTimezoneOffset() / 60);
    }

    toDate(): Date {
        if (!this.enabled) {
            return null;
        }

        return new Date(this.date + ' ' + this.time + ' GMT' + (this.offset >= 0 ? '+' : '') + this.offset + '00'); //.toISOString();
    }
}

export class FirmwareFamilyInfo {
    familyId: string;
    familyDisplayName: string;
    devices: DeviceInfo[];
    modelName: string;
    targetAndroidVersion: AndroidGroupType;
    updateInfo: FirmwareUpdateInfo;
    updateMethod: FwUpdateMethod;
    customURL: string;
    needUpdate: boolean;

    constructor() {
        this.devices = [];
        this.updateMethod = FwUpdateMethod.Unknown;
        this.needUpdate = false;
    }
}

